import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SortEnum } from 'src/app/utils/enums/sort-enum';
import { CombinatedDroits } from 'src/app/utils/interfaces/new/combinateddroits.interface';
import { Droit } from 'src/app/utils/interfaces/new/droit.interface';
import { Filtres } from 'src/app/utils/interfaces/new/filtres.interface';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { Role } from 'src/app/utils/interfaces/new/role.interface';
import { environment } from 'src/environments/environment';
import { FiltresService } from '../filtres/filtres.service';
import { SnackbarService } from '../snackbar/snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class DroitsService {

  public isBdg = false;

  private httpOptions = {
    withCredentials: true,
    observe: 'response' as 'response',
    headers: new HttpHeaders()
  };

  constructor(
    private http: HttpClient,
    private _filtresService: FiltresService,
    private _snack: SnackbarService
  ) { }

  public async find(filtre: Filtres = {
    perpage: -1,
    currentPage: 1,
    sortOrder: SortEnum.ASC,
    sortBy: 'nom'
  }): Promise<Paginated<Droit>> {
    try {
      this.httpOptions.headers = this._filtresService.setHeaders(filtre);
      const res = await this.http.get(`${environment.basePath}/hypermed/droits`, this.httpOptions).toPromise();
      const roles = res.body as Role[];
      const paginated: Paginated<Role> = {
        page: Number(res.headers.get('x-page')),
        perpage: Number(res.headers.get('x-per-page')),
        total: Number(res.headers.get('x-total')),
        objects: roles
      };
      return paginated;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async findMyCombinedDroits(): Promise<CombinatedDroits> {
    try {
      const res = await this.http.get(`${environment.basePath}/hypermed/users/me/droits`, this.httpOptions).toPromise();
      const combinatedDroits = res.body as CombinatedDroits;
      return combinatedDroits;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }
}
